import {BibUsuarioModel} from '@/models/biblioteca/bibusuario/bibusuario.model';
import api from '@/services/axios/api';
import {AxiosResponse} from 'axios';
import {DataSource, FiltrosModel} from '@/datasources/consulte-grid';
import TextoValor from '@/models/texto-valor';
import {RegisterOutput} from '@/models/register-output';
import { useStore } from '@/store';


class BibUsuarioService {
 dadosIndexPaginado(
  pagina: number,
  itensPorPagina: number,
  filters: FiltrosModel[],
  gesEscolaIdParam?: number
 ): Promise<AxiosResponse<DataSource<BibUsuarioModel>>> {
        const gesEscolaId = gesEscolaIdParam ?? useStore().getters.getCodigoEscola;
        const ano  = useStore().getters.getAno; 
    
  return api.post <DataSource <BibUsuarioModel>>('/BibUsuario/RetornoPaginado', {
   rowsPerPage:  itensPorPagina,
   pageNumber: pagina,
   filters: filters
  },
    {
    params: {
      Ano: ano,
      GesEscolaId: gesEscolaId,
    },
   });
 }

 inserirAtualizar(bibUsuario: BibUsuarioModel): Promise<AxiosResponse<RegisterOutput>> {
  const result = api.post('/BibUsuario', bibUsuario);
  return result;
 }

 remover(id: number): Promise<AxiosResponse> {
  return api.delete('/BibUsuario/' + id);
 }

 atualizar(bibUsuario: BibUsuarioModel): Promise<AxiosResponse> {
  return api.put('/BibUsuario', bibUsuario);
 }

 async get(id: number): Promise<BibUsuarioModel> {
  const result = await api.get<BibUsuarioModel>(`/BibUsuario/${id.toString()}`);
  return result.data;
 }
}
export default new BibUsuarioService();
